import { useState, type FormEvent } from 'react';

interface Props {
  busy: boolean;
  defaultRegion: string;
  notify: boolean;
  onRegion: (r: string) => void;
  onNotify: (v: boolean) => void;
  onSubmit: (phone: string) => void;
}

export function PhoneSearch({ busy, defaultRegion, notify, onRegion, onNotify, onSubmit }: Props) {
  const [phone, setPhone] = useState('');

  function submit(e: FormEvent) {
    e.preventDefault();
    if (!phone.trim() || busy) return;
    onSubmit(phone.trim());
  }

  return (
    <form className="search" onSubmit={submit}>
      <div className="search__row">
        <div className="search__field">
          <span className="search__prefix">TEL</span>
          <input
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            placeholder="+1 415 555 2671  ·  or national with region"
            inputMode="tel"
            autoComplete="tel"
            spellCheck={false}
            disabled={busy}
          />
          {busy && <span className="search__spin" aria-label="Loading" />}
        </div>
        <select
          className="search__region"
          value={defaultRegion}
          onChange={(e) => onRegion(e.target.value)}
          title="Default region when number has no +"
          disabled={busy}
        >
          {['US', 'CA', 'GB', 'AU', 'DE', 'FR', 'IN', 'MX', 'BR', 'JP'].map((c) => (
            <option key={c} value={c}>
              {c}
            </option>
          ))}
        </select>
        <button className="btn btn--primary" type="submit" disabled={busy || !phone.trim()}>
          {busy ? 'SCAN…' : 'LOOKUP'}
        </button>
      </div>
      <label className="search__notify">
        <input type="checkbox" checked={notify} onChange={(e) => onNotify(e.target.checked)} />
        <span>Notify via web push when complete</span>
      </label>
    </form>
  );
}
